// basic options for Highcharts plot
export const default_options = {
  title: {
    text: 'Groundwater Status'
  },
  subtitle: {
    text: '.'
  },
  yAxis: {
    title: {
        text: "Depth to water level (feet below land surface)"
    },
    reversed: true,
  },
  xAxis: {
    type: "datetime",
    gridLineWidth: 1,
    dateTimeLabelFormats: {
      month: '%e-%b',
      day: '%e-%b',
      hour: '%e-%b'
    },
    gridLineWidth: 1,
  },
  chart: {
    zoomType: "x",
    height: window.innerHeight * 0.75,
  },
  legend: {
    symbolRadius: 0 //symbol legend square instead of default circle
  },
  credits: {
    enabled: false,
  //  href: "https://nedews.nrcc.cornell.edu",
  //  text: "Northeast DEWS"
  },
  tooltip: {
    shared: true,
    dateTimeLabelFormats: {
      month: '%B %e',
      day: '%B %e',
      hour: '%B %e'
    },
  },
  series: [],    //added later
};